module.exports = {
      id: "pre-blue-barrier-free-environment-usage",
      viewBox: "0 0 46 46",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#pre-blue-barrier-free-environment",
      toString: function () {
        return this.url;
      }
    }